import {useRef,useState,createElement} from "react";
import {saveAs} from "file-saver";
// The PDF renderer and all report pages are lazy-loaded only when exporting.
export default function ReportPDF({report,label='Export PDF'}){
 const [working,setWorking]=useState(false),[failed,setFailed]=useState(false),inFlight=useRef(false);
 const download=async()=>{
  if(inFlight.current)return;
  inFlight.current=true;setWorking(true);setFailed(false);
  try{
   const [{pdf},{CompanyReportDocument}]=await Promise.all([
    import("@react-pdf/renderer"),import("./ReportDocument.jsx")
   ]);
   const blob=await pdf(createElement(CompanyReportDocument,{report})).toBlob();
   const filename=String(report.rows.length===1?report.rows[0].id:report.title||'Report')
     .replace(/[^a-zA-Z0-9._-]/g,'_')+'.pdf';
   saveAs(blob,filename);
  }catch(error){console.error('Report PDF generation failed',error);setFailed(true);}
  finally{inFlight.current=false;setWorking(false);}
 };
 return <button type="button" className="topBtn" disabled={working} onClick={download}
   title="Export all currently filtered report records to PDF">
   {working?'Preparing PDF…':failed?'Retry PDF':label}
 </button>;
}
